<template>
	<div>
		<el-carousel :height="computeHeight">
			<el-carousel-item v-for="(item, index) in sliders" :key="index"><img :src="item.img" class="slider_img" /></el-carousel-item>
		</el-carousel>
		<!-- <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                一站式解决方案
            </div>
        </div> -->
		<!-- 盒子 -->
		<div class="border_parent" style="background: linear-gradient(to bottom, #f3f9ff, #fff);">
			<el-row :gutter="10" style="display: flex;justify-content: center;">
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border">
						<div class="border_img_parent"><img src="http://dgoss.91dageng.com.cn/png/x6Bdmw2AELvjq3pC0110_组 8@3x.png" class="img_border" /></div>
						<div class="border_title">关于我们</div>
						<div class="border_content_one">About us</div>
						<div class="border_content_two">
							<div @click="handleSelect('3')" style="border: 1px solid #0775FF;padding: 4px;">
								了解更多
								<span>→</span>
							</div>
						</div>
					</div>
				</el-col>
				<!-- <el-col :xs="12" :sm="12" :md="6">
					<div class="border">
						<div class="border_img_parent"><img src="http://dgoss.91dageng.com.cn/png/OswNrNk8ZywrxJ8b1331_组 10@3x.png" class="img_border" /></div>
						<div class="border_title">产品信息</div>
						<div class="border_content_one">Product Information</div>
						<div class="border_content_two">
							<div @click="handleSelect('4')" style="border: 1px solid #0775FF;padding: 4px;">
								了解更多
								<span>→</span>
							</div>
						</div>
					</div>
				</el-col> -->
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border">
						<div class="border_img_parent"><img src="http://dgoss.91dageng.com.cn/png/MCREA3m15lWGku6E2012_组 12@3x.png" class="img_border" /></div>
						<div class="border_title">行业咨询</div>
						<div class="border_content_one">Industry Information</div>
						<div class="border_content_two">
							<div @click="handleSelect('5')" style="border: 1px solid #0775FF;padding: 4px;">
								了解更多
								<span>→</span>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border" style="margin-right: 0">
						<div class="border_img_parent"><img src="http://dgoss.91dageng.com.cn/png/BJ9bGiX1QygxqSua0230_组 12@13x.png" class="img_border" /></div>
						<div class="border_title">联系我们</div>
						<div class="border_content_one">Contact us</div>
						<div class="border_content_two">
							<div @click="handleSelect('6')" style="border: 1px solid #0775FF;padding: 4px;">
								了解更多
								<span>→</span>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import { selRotograph } from '@/utils/api';
export default {
	name: 'Index',
	data() {
		return {
			sliders: [],
			carousel_height: '550px'
		};
	},
	methods: {
		
			handleSelect(key) {
			sessionStorage.setItem('key', key);
				switch (key) {
					case '1':
						this.$router.push({ name: 'Index' });
						this.currentMenu = '首页';
						break;
					case '2-1':
						// window.location.hash = '#产品微观';
						break;
					case '2-2':
						this.$router.push({ name: 'Fruit' });
						break;
					case '2-3':
						this.$router.push({ name: 'Fashion' });
						break;
					case '3':
						this.$router.push({ name: 'company' });
						// window.location.hash = '#关于我们';
						this.currentMenu = '关于我们';
						break;
					// case '4':
					// 	this.$router.push({ name: 'product' });
					// 	// window.location.hash = '#产品信息';
					// 	this.currentMenu = '产品信息';
					// 	break;
					case '5':
						this.$router.push({ name: 'Information' });
						// window.location.hash = '#行业资讯';
						this.currentMenu = '行业资讯';
						break;
					case '6':
						this.$router.push({ name: 'Aboutus' });
						// window.location.hash = '#联系我们';
						this.currentMenu = '联系我们';
						break;
				}
			},
		async selbanner() {
			let a = await selRotograph({ sortName: 'WEB_INDEX_BANNER' });
			if (a.code == 200) {
				this.sliders = a.data;
			}
		}
	},
	created() {
		this.selbanner();
	},
	// mounted() {
	// 	this.sliders = [
	// 		{
	// 			img: require('../../static/slider/a1.jpg')
	// 		},
	// 		{
	// 			img: require('../../static/slider/a2.jpg')
	// 		},
	// 		{
	// 			img: require('../../static/slider/a3.jpg')
	// 		},
	// 		{
	// 			img: require('../../static/slider/a4.jpg')
	// 		}
	// 	];
	// },
	computed: {
		//计算高度
		computeHeight() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 415) {
				return '550px';
			} else {
				return '250px';
			}
		},
		computeArrowImg() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 450) {
				return require('../../static/other/arrow.png');
			} else {
				return require('../../static/other/arrow_down.png');
			}
		}
	}
};
</script>

<style>
::-webkit-scrollbar {
	width: 0 !important;
}
::-webkit-scrollbar {
	width: 0 !important;
	height: 0;
}
.border_parent {
	width: 90%;
	margin: 50px auto;
	/*  */
}

.slider_img {
	/* height: 550px; */
	width: 100%;
}

.solve {
	margin-top: 30px;
	margin-bottom: 10px;
}

.border {
	border-radius: 6px;
	/* border: 1px solid #EBEEF5; */
	height: auto;
	margin: 10px;
	/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}

.border_one {
	margin-left: 0;
}

.border_img_parent {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.product_mobile_content {
	height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.product_mobile_img {
	width: 50%;
}

.product_mobile_title {
	font-weight: bold;
	text-align: center;
}

.product_pc_one {
	text-align: center;
	min-height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.font_size_30 {
	font-size: 1.875em;
}

.product_font_style {
	font-size: 1.125em;
}

.product_pc_img {
	width: 100%;
}

.product_pc_img_div {
	width: 50%;
	float: left;
	display: flex;
	align-items: center;
}

.product_pc {
	display: flex;
	width: 90%;
	margin: 20px auto;
	background: #f2f6fc;
	align-items: center;
}

.product_spec_title {
	margin-top: 30px;
	margin-bottom: 10px;
}

.product_spec_parent {
	display: flex;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.cooperation_parent {
	display: flex;
	justify-content: center;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.border_spec {
	border-radius: 6px;
	border: 1px solid #ebeef5;
	float: left;
	width: 25%;
	height: auto;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
	font-size: 1.25em;
	font-weight: normal;
	padding: 0 20px;
	margin: 10px;
	color: #fff;
}

.border_title {
	font-family: 'PingFang SC';
	margin-top: 10px;
	font-size: 1.125em;
	font-weight: bold;
	text-align: center;
}

.border_content_one {
	margin-top: 20px;
	/* font-size: 1.125em; */
	color: #999;
	text-align: center;
}

.border_content_two {
	margin-top: 5px;
	font-size: 1.125em;
	margin-bottom: 25px;
	text-align: center;
	color: #0775ff;
	display: flex;
	justify-content: center;
}

.img_border {
	margin-top: 15px;
	width: 80px;
	height: 80px;
}

.border_spec_inner_one {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 35px;
	height: 70px;
}

.border_spec_content_one {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	text-align: center;
}

.border_spec_inner_last {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	margin-bottom: 25px;
	text-align: center;
}

.cooperation {
	margin-top: 30px;
	width: 100%;
}

.about_me {
	display: flex;
	margin-top: 30px;
	justify-content: center;
	width: 100%;
}

.product_mobile {
	width: 90%;
	align-items: center;
	margin: 20px auto;
	background: #f2f6fc;
}

.product_mobile_img_div {
	width: 50%;
	height: auto;
}

.product_mobile_content_one {
	margin-top: 20px;
	text-align: center;
}

.product_mobile_content_two {
	margin-top: 10px;
	text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
	.slider_img {
		height: 250px;
		width: 100%;
	}

	.border_parent {
		display: flex;
		width: 90%;
		margin: auto;
		height: auto;
		flex-direction: column;
		background: linear-gradient(to bottom, #f3f9ff, #fff);
	}

	.border {
		border-radius: 6px;
		/* border: 1px solid #EBEEF5; */
		float: left;
		width: 100%;
		height: auto;
		margin: 10px 0 auto;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
		/*background: aquamarine;*/
	}

	.border_img_parent {
		margin-top: 0;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		height: auto;
		background: #f2f6fc;
	}

	.product_mobile_content {
		width: 100%;
		margin-top: 15px;
	}

	.product_mobile_content_one {
		margin-top: 5px;
	}

	.product_mobile_content_two {
		margin-top: 5px;
	}

	.product_mobile_img_div {
		display: flex;
		width: 100%;
		height: auto;
		justify-content: center;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.product_mobile_img {
		float: left;
	}

	.product_mobile_title {
		font-weight: bold;
	}

	.product_pc_one {
		width: 100%;
		margin-top: 15px;
	}

	.font_size_30 {
		font-size: 1.25em;
	}

	.product_font_style {
		font-size: 1em;
	}

	.product_pc_img {
		height: 280px;
		width: 320px;
	}

	.product_pc_img_div {
		width: 100%;
		float: left;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_pc {
		display: flex;
		width: 90%;
		height: auto;
		margin: 20px auto;
		background: #f2f6fc;
		flex-direction: column;
	}

	.head-label {
		display: flex;
		margin-top: 10px;
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		align-items: center;
		justify-content: center;
		margin: 20px auto;
		height: auto;
		flex-direction: column;
	}

	.border_spec {
		float: left;
		height: auto;
		margin: 8px;
		width: 100%;
		border-radius: 6px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.border_title {
		font-family: 'PingFang SC';
		margin-top: 5px;
		font-size: 1.125em;
		font-weight: bold;
	}

	.border_content_one {
		margin-top: 5px;
		color: #999999;
		/* font-size: 1.125em; */
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125em;
		margin-bottom: 8px;
		color: #0775ff;
		display: flex;
		justify-content: center;
	}

	.img_border {
		margin-top: 8px;
		width: 80px;
		height: 80px;
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 8px;
		/*background-color: aqua;*/
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
	}

	.border_spec_inner_last {
		/*background-color: bisque;*/
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
		margin-bottom: 8px;
	}

	.about_me {
		display: flex;
		margin-top: 10px;
		width: 100%;
	}
}

.border_spec_img {
	width: 75px;
	height: 55px;
	align-self: center;
}

.font_size_24 {
	font-size: 1.5em;
}
</style>
